export default __webpack_public_path__ + "3c8733a229beacd864e8b4b147126dce.svg";